<template>
  <div class="p-5 h-screen overflow-y-auto">
    <div class="flex items-center mb-3">
      <a-select class="w-[200px]" v-model="swPick" placeholder="請選擇程式" @change="ChangeProgram">
        <a-select-option v-for="item of swArray" :key="item.value" :value="item.value">
          {{ item.name }}
        </a-select-option>
      </a-select>
      <span class="ml-3">
        非 <template><a-input style="width: 200px" v-model="testversion" @change="SearchonChange" placeholder="版號" /></template> 版本
      </span>
      <div class="tt flex items-center justify-end">
        <a-button type="primary" icon="download" :disabled="!isExportEnabled" @click="ExportReport" class="mr-2">
          匯出報表
        </a-button>
        <a-popconfirm
          title="會對所有機台發送掃描，用來新增新機台與更新移機資訊，確定要執行？"
          ok-text="確定"
          cancel-text="取消"
          :disabled="scanCooldown > 0"
          @confirm="RescanDevices"
        >
          <a-button icon="scan" :disabled="scanCooldown > 0" class="mr-2">
            {{ scanCooldown > 0 ? `重新掃描機台（${scanCooldown}s）` : '重新掃描機台' }}
          </a-button>
        </a-popconfirm>
        <a-button @click="Reload()">
          <span class="icon-wrapper">
            <a-icon v-if="isClick" type="sync" style="color: blue" spin />
            <a-icon v-else type="reload" style="color: blue" />
          </span>
          <span class="text-wrapper">重新讀取裝置</span>
        </a-button>
      </div>
    </div>

    <a-table class="" :data-source="showDeviceList" :columns="columns" :rowKey="(record) => record.device_mac">
      <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }" style="padding: 8px">
        <a-input
          v-ant-ref="(c) => (searchInput = c)"
          :placeholder="`Search ${column.dataIndex}`"
          :value="selectedKeys[0]"
          style="width: 188px; margin-bottom: 8px; display: block"
          @change="(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])"
          @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)"
        />
        <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px" @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
          Search
        </a-button>
        <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)"> Reset </a-button>
      </div>
      <a-icon slot="filterIcon" slot-scope="filtered" type="search" :style="{ color: filtered ? '#108ee9' : undefined }" />
      <template slot="customRender" slot-scope="text, record, index, column">
        <span v-if="column.dataIndex === 'kioskFrontend.version'">
          <span>{{ GetVersion(record, "kioskFrontend") }}</span>
        </span>
        <span v-else-if="column.dataIndex === 'paymentKiosk.version'">
          <span>{{ GetVersion(record, "paymentKiosk") }}</span>
        </span>
        <span v-else-if="column.dataIndex === 'CSHM.version'">
          <span>{{ GetVersion(record, "CSHM") }}</span>
        </span>
        <span v-else-if="column.dataIndex === 'supervisory.version'">
          <span>{{ GetVersion(record, "supervisory") }}</span>
        </span>
        <div v-else-if="column.dataIndex === 'memoryInfo' || column.dataIndex === 'diskInfo'" class="resource-cell" :class="{ offline: !IsOnline(record) }">
          <template v-if="UsageView(record, column.dataIndex)">
            <div>{{ UsageView(record, column.dataIndex).text }}</div>
            <a-progress
              :percent="UsageView(record, column.dataIndex).percent"
              :stroke-color="UsageView(record, column.dataIndex).color"
              size="small"
            />
            <div v-if="column.dataIndex === 'diskInfo'" class="resource-sub">{{ UsageView(record, column.dataIndex).freeText }}</div>
          </template>
          <span v-else>--</span>
        </div>
        <div v-else-if="column.dataIndex === 'networkInfo'" class="resource-cell" :class="{ offline: !IsOnline(record) }">
          <template v-if="NetworkView(record)">
            <div>↑ {{ NetworkView(record).send }}</div>
            <div>↓ {{ NetworkView(record).recv }}</div>
          </template>
          <span v-else>--</span>
        </div>
        <template v-else>
          <!-- 对其他列维持原样 -->
          <span
            v-if="column.dataIndex === 'device_name'"
            class="online-dot"
            :class="IsOnline(record) ? 'online' : 'offline'"
            :title="OnlineTitle(record)"
          ></span>
          <span>
            <span v-if="searchText && searchedColumn === column.dataIndex">
              <template v-for="(fragment, i) in text.toString().split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))">
                <mark v-if="fragment.toLowerCase() === searchText.toLowerCase()" :key="i" class="highlight">{{ fragment }}</mark>
                <template v-else>{{ fragment }}</template>
              </template>
            </span>
            <span v-else>{{ text }}</span>
          </span>
        </template>
      </template>
    </a-table>
  </div>
</template>

<script>
import * as XLSX from 'xlsx'
import FileSaver from 'file-saver'

export default {
  name: 'DeviceList',

  data () {
    return {
      baseURL: this.GLOBAL.baseURL,
      basePort: this.GLOBAL.basePort,
      searchText: '',
      searchInput: null,
      searchedColumn: '',
      kioskFrontendVersion: '',
      testversion: null,
      deviceList: [],
      showDeviceList: [],
      swPick: undefined,
      isClick: false,
      scanCooldown: 0,
      scanCooldownTimer: null,
      scanReloadTimer: null,
      swArray: [
        {
          name: 'supervisory監控',
          value: 'supervisory'
        },
        {
          name: '前端版本',
          value: 'kioskFrontend'
        },
        {
          name: '後端版本',
          value: 'paymentKiosk'
        },
        {
          name: 'CSHM版本',
          value: 'CSHM'
        }
      ],
      columns: [
        {
          title: '裝置名稱',
          dataIndex: 'device_name',
          key: 'device_name',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'customRender'
          },
          onFilter: (value, record) => {
            return record.device_name.toString().toLowerCase().includes(value.toLowerCase())
          },
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus()
              }, 0)
            }
          }
        },
        {
          title: 'Mac Address',
          dataIndex: 'device_mac',
          key: 'device_mac',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'customRender'
          },
          onFilter: (value, record) => record.device_mac.toString().toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus()
              })
            }
          }
        },
        {
          title: 'supervisory',
          dataIndex: 'supervisory.version',
          // key: 'supervisory.version',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'customRender'
          },
          onFilter: (value, record) => {
            const version = record.swList?.find((item) => item.name === 'supervisory')?.version || '-'
            return version.toString().toLowerCase().includes(value.toLowerCase())
          },
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus()
              })
            }
          }
        },
        {
          title: '前端版本',
          dataIndex: 'kioskFrontend.version',
          key: 'kioskFrontend.version',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'customRender'
          },
          onFilter: (value, record) => {
            const version = record.swList?.find((item) => item.name === 'kioskFrontend')?.version || '-'
            return version.toString().toLowerCase().includes(value.toLowerCase())
          },
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus()
              })
            }
          }
        },
        {
          title: '後端版本',
          dataIndex: 'paymentKiosk.version',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'customRender'
          },
          onFilter: (value, record) => {
            const version = record.swList?.find((item) => item.name === 'paymentKiosk')?.version || '-'
            return version.toString().toLowerCase().includes(value.toLowerCase())
          },
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus()
              })
            }
          }
        },
        {
          title: 'CSHM版本',
          dataIndex: 'CSHM.version',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'customRender'
          },
          onFilter: (value, record) => {
            const version = record.swList?.find((item) => item.name === 'CSHM')?.version || '-'
            return version.toString().toLowerCase().includes(value.toLowerCase())
          },
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus()
              })
            }
          }
        },
        {
          title: '記憶體',
          dataIndex: 'memoryInfo',
          key: 'memoryInfo',
          width: 170,
          scopedSlots: { customRender: 'customRender' },
          sorter: (a, b, sortOrder) => this.CompareMetric(a, b, sortOrder, (r) => r.ipc?.performance?.memory)
        },
        {
          title: '硬碟',
          dataIndex: 'diskInfo',
          key: 'diskInfo',
          width: 170,
          scopedSlots: { customRender: 'customRender' },
          sorter: (a, b, sortOrder) => this.CompareMetric(a, b, sortOrder, (r) => r.ipc?.performance?.storage)
        },
        {
          title: '網路',
          dataIndex: 'networkInfo',
          key: 'networkInfo',
          width: 130,
          scopedSlots: { customRender: 'customRender' },
          sorter: (a, b, sortOrder) => this.CompareMetric(a, b, sortOrder, (r) => this.NetworkTotalRate(r))
        }
      ]
    }
  },
  computed: {
    mqttClient: {
      get () {
        return this.$store.state.mqttClient
      },
      set () {}
    },
    // deviceList: {
    //   get () {
    //     return this.$store.state.deviceList
    //   },
    //   set () {}
    // }
    isExportEnabled () {
      return this.swPick &&
             this.testversion &&
             this.testversion.trim().length > 0 &&
             this.showDeviceList.length > 0
    }
  },
  created () {
    this.GetDeviceList()
  },
  mounted () {
    // setInterval(() => {
    //   this.GetDeviceList()
    // }, 6000)
  },
  beforeDestroy () {
    clearInterval(this.scanCooldownTimer)
    clearTimeout(this.scanReloadTimer)
  },

  methods: {
    Reload () {
      if (this.isClick) return
      this.isClick = true
      this.swPick = undefined
      this.testversion = null
      this.GetDeviceList()
    },
    ChangeProgram (swPick) {
      this.swPick = swPick
    },
    SearchonChange () {
      if (!this.swPick || this.testversion.length < 5) return // 沒選擇要查的程式就忽略
      this.showDeviceList = this.deviceList.filter((item) => {
        if (!item.swList) {
          return true
        }
        return item.swList?.find((item) => item.name === this.swPick)?.version !== this.testversion
      })
      console.log(this.deviceList.length)
    },
    GetVersion (record, name) {
      const version = record.swList?.find((item) => item.name === name)?.version || '--'
      return version
    },
    IsOnline (record) {
      return record.status === 1
    },
    OnlineTitle (record) {
      const state = this.IsOnline(record) ? '在線' : '離線'
      if (!record.timestempKeep) return state
      return `${state}｜最後回報 ${new Date(record.timestempKeep * 1000).toLocaleString('zh-TW', { hour12: false })}`
    },
    FormatGB (bytes) {
      return (bytes / 1024 ** 3).toFixed(1)
    },
    FormatRate (bytesPerSecond) {
      const bits = bytesPerSecond * 8
      if (bits >= 1000 ** 2) return `${(bits / 1000 ** 2).toFixed(1)} Mbps`
      if (bits >= 1000) return `${(bits / 1000).toFixed(1)} Kbps`
      return `${Math.round(bits)} bps`
    },
    UsageColor (percent, online) {
      if (!online) return '#bfbfbf'
      if (percent >= 90) return '#f5222d'
      if (percent >= 80) return '#fa8c16'
      return '#52c41a'
    },
    // ipc 由 supervisory heartbeat 提供，舊版機台沒有此欄位
    UsageView (record, dataIndex) {
      const ipc = record.ipc
      if (!ipc) return null
      const isMemory = dataIndex === 'memoryInfo'
      const capacity = isMemory ? ipc.memory : ipc.storage
      const percent = ipc.performance?.[isMemory ? 'memory' : 'storage']
      if (!capacity || capacity.size === undefined || percent === undefined) return null
      return {
        text: `${this.FormatGB(capacity.used)} / ${this.FormatGB(capacity.size)} GB`,
        freeText: `可用 ${this.FormatGB(capacity.free)} GB`,
        percent: Number(percent),
        color: this.UsageColor(percent, this.IsOnline(record))
      }
    },
    // ipc.performance.network 的 send / recv 單位為 bytes/s
    NetworkView (record) {
      const net = record.ipc?.performance?.network
      if (!net || net.send === undefined || net.recv === undefined) return null
      return {
        send: this.FormatRate(net.send),
        recv: this.FormatRate(net.recv)
      }
    },
    NetworkTotalRate (record) {
      const net = record.ipc?.performance?.network
      if (!net || net.send === undefined || net.recv === undefined) return undefined
      return net.send + net.recv
    },
    // 沒有資料的機台不論升冪或降冪都排在最後（antd 降冪時會把結果反轉）
    CompareMetric (a, b, sortOrder, getValue) {
      const va = getValue(a)
      const vb = getValue(b)
      const missingA = va === undefined || va === null
      const missingB = vb === undefined || vb === null
      if (missingA && missingB) return 0
      if (missingA) return sortOrder === 'descend' ? -1 : 1
      if (missingB) return sortOrder === 'descend' ? 1 : -1
      return va - vb
    },
    handleSearch (selectedKeys, confirm, dataIndex) {
      confirm()
      this.searchText = selectedKeys[0]
      this.searchedColumn = dataIndex
    },
    handleReset (clearFilters) {
      clearFilters()
      this.searchText = ''
    },
    GetDeviceList () {
      this.axios
        .post(this.baseURL + this.basePort + '/device/deviceList', {})
        .then((res) => {
          console.log(res.data)
          if (res.data.message === 'success') {
            this.$store.commit('deviceList', res.data.data)
            this.deviceList = res.data.data
            this.showDeviceList = res.data.data
          } else {
          }
        })
        .catch((error) => {
          // 處理上傳失敗的回應
          console.error(error)
        })
        .finally(() => {
          setTimeout(() => {
            this.isClick = false
          }, 600)
        })
    },
    PublishScan () {
      const inf = JSON.stringify({})
      // eslint-disable-next-line no-undef
      const message = new Paho.MQTT.Message(inf)
      message.destinationName = 'scan'
      this.mqttClient.send(message)
    },
    // 後端只在 Pod 啟動時 scan 一次；新註冊或移機的機台要重新 scan 才會寫入 / 更新 device_list。
    // scan 是全域 topic（約 3000 台都會回覆），以冷卻時間避免重複觸發。
    RescanDevices () {
      if (this.scanCooldown > 0) return
      if (!this.mqttClient || !this.mqttClient.isConnected()) {
        this.$message.error('MQTT 尚未連線，無法發送掃描，請稍後再試')
        return
      }

      try {
        this.PublishScan()
      } catch (error) {
        console.error(error)
        this.$message.error('發送掃描失敗，請稍後再試')
        return
      }

      const reloadDelaySec = 10
      this.$message.success(`已發送掃描，${reloadDelaySec} 秒後自動重新讀取裝置`)
      this.scanReloadTimer = setTimeout(() => this.GetDeviceList(), reloadDelaySec * 1000)

      this.scanCooldown = 60
      this.scanCooldownTimer = setInterval(() => {
        this.scanCooldown -= 1
        if (this.scanCooldown <= 0) {
          clearInterval(this.scanCooldownTimer)
          this.scanCooldownTimer = null
        }
      }, 1000)
    },
    ExportReport () {
      if (!this.isExportEnabled) return

      const exportData = this.showDeviceList.map((device) => {
        const memory = this.UsageView(device, 'memoryInfo')
        const disk = this.UsageView(device, 'diskInfo')
        const network = this.NetworkView(device)
        const memoryCap = device.ipc?.memory || {}
        const storageCap = device.ipc?.storage || {}
        return {
          裝置名稱: device.device_name || '',
          'Mac Address': device.device_mac || '',
          在線狀態: this.IsOnline(device) ? '在線' : '離線',
          supervisory版本: this.GetVersion(device, 'supervisory'),
          前端版本: this.GetVersion(device, 'kioskFrontend'),
          後端版本: this.GetVersion(device, 'paymentKiosk'),
          CSHM版本: this.GetVersion(device, 'CSHM'),
          '記憶體使用率(%)': memory ? memory.percent : '',
          '記憶體已用(GB)': memory ? this.FormatGB(memoryCap.used) : '',
          '記憶體總量(GB)': memory ? this.FormatGB(memoryCap.size) : '',
          '硬碟使用率(%)': disk ? disk.percent : '',
          '硬碟已用(GB)': disk ? this.FormatGB(storageCap.used) : '',
          '硬碟可用(GB)': disk ? this.FormatGB(storageCap.free) : '',
          '硬碟總量(GB)': disk ? this.FormatGB(storageCap.size) : '',
          網路上傳: network ? network.send : '',
          網路下載: network ? network.recv : ''
        }
      })

      const ws = XLSX.utils.json_to_sheet(exportData)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, '裝置過濾報表')

      const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
      const blob = new Blob([excelBuffer], { type: 'application/octet-stream' })
      FileSaver.saveAs(blob, `裝置過濾報表_${new Date().toISOString().slice(0, 10)}.xlsx`)
    }
  }
}
</script>

<style lang="css" scoped>
.tt {
  flex-grow: 3;
  text-align: right;
}
.online-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 6px;
  vertical-align: middle;
}
.online-dot.online {
  background: #52c41a;
  box-shadow: 0 0 4px #52c41a;
}
.online-dot.offline {
  background: #f5222d;
}

.resource-cell {
  font-size: 12px;
  line-height: 1.5;
  white-space: nowrap;
}
.resource-cell.offline {
  color: #bfbfbf;
}
.resource-sub {
  color: #8c8c8c;
}
.resource-cell.offline .resource-sub {
  color: #bfbfbf;
}

.icon-wrapper {
  display: inline-flex;
  align-items: center;
}

.text-wrapper {
  display: inline-flex;
  align-items: center;
  margin-left: 5px; /* 根据需要调整间距 */
}

a-button {
  display: inline-flex;
  align-items: center;
}
</style>
